import { AggregateFormulaValue } from '@modules/quantify/components/AggregateFormulaResultTable/AggregateFormulaValue';
import { ShowFeedbackDrawerFromTableOptions } from '@modules/quantify/components/QuantifyReportTableWidget/types';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';

interface getSingleRecordQueryValueColumnParams {
  headerName: string;
  onFeedbackCountClick: (params: ShowFeedbackDrawerFromTableOptions) => void;
}

export function getSingleRecordQueryValueColumn({
  headerName,
  onFeedbackCountClick,
}: getSingleRecordQueryValueColumnParams) {
  const renderValueCell = (params: GridRenderCellParams<any, number>) => {
    return (
      <AggregateFormulaValue
        value={params.row?.value}
        nps={params.row?.nps}
        csat={params.row?.csat}
        mean={params.row?.mean}
        onFeedbackCountClick={onFeedbackCountClick}
      />
    );
  };

  const valueColumn: GridColDef = {
    field: 'value',
    headerName,
    minWidth: 200,
    flex: 1,
    renderCell: renderValueCell,
    sortable: false,
    type: 'number',
    headerAlign: 'left',
    align: 'left',
  };

  return valueColumn;
}
